import { QueryClient } from "@tanstack/react-query";

export const delegationQueryKeys = {
  invitations: ["delegations", "invitations"] as const,
  active: ["delegations", "active"] as const,
  history: ["delegations", "history"] as const,
  context: ["delegations", "context"] as const,
};

export const invalidateDelegationQueries = (queryClient: QueryClient) => {
  queryClient.invalidateQueries({ queryKey: delegationQueryKeys.invitations });
  queryClient.invalidateQueries({ queryKey: delegationQueryKeys.active });
  queryClient.invalidateQueries({ queryKey: delegationQueryKeys.history });
  queryClient.invalidateQueries({ queryKey: delegationQueryKeys.context });
};
